/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import { useSelector, useDispatch } from 'react-redux';
import { Autocomplete } from '@mui/material';
import { toast } from 'react-toastify';
import EditTwoTone from '@material-ui/icons/ArrowDropDown';
import _isEmpty from 'lodash/isEmpty';
import service from '../../apis/service';
import Filter from '../../assets/SvgFilter';
import AddGuideInstructor from './AddGuideInstructor';
import 'react-toastify/dist/ReactToastify.css';
import Theme from '../ui/Theme';
import AddNewTag from './AddNewTag';
import Modal from '../common/Modal';
import ExclamationIcon from '../../assets/ExclamationIcon';

import {
  getGuideTagList,
  getCheckedInstr,
  getJourneyDetails,
  showProgress,
  getGuideInstructorList,
  getCheckedAssignedInstr,
  getGuideDetails,
} from '../../redux/actions/DealershipActions';

import { UploadFolderButton } from './UploadButton';
import CustomUploadField from '../shared/CustomUploadField';
import { DIMENSIONS } from '../../constants/aspectRatio';
import AvatarGroupComp from '../dailydose/AvatarGroupComp';
import AssignInstructor from './AssignInstructor';
import MainLayoutStyles from '../../styles/MainLayoutStyle';
import { ErrorToast, generateVideoUrl } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';
import ZeroState from '../common/ZeroState';
import { CustomReactPlayer } from '../common/ReactPlayer';
import useAiExercise from './hooks/useAiExercise';
import { VideoLinkInput } from '../../features/vimeo-picker';

toast.configure();
const useStyles = makeStyles((theme) => ({
  avatarValue: {
    marginLeft: '4px',
  },
  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  courseovtitle: {
    color: 'rgba(0, 0, 0, 0.4)',
    textAlign: 'left',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
  },
  instStyle: {
    backgroundColor: Theme.palette.secondary.main,
    height: '41px',
    width: '361px',
    padding: '5px 5px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: 'black',
  },
  resize: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '375px',
    padding: '5px 10px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    marginTop: '9px',
    color: 'black',
  },

  resize2: {
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '375px',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: 'black',
  },
  resize4: {
    backgroundColor: Theme.palette.secondary.main,
    height: '41px',
    width: '395px',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: 'black',
  },
  resize3: {
    backgroundColor: Theme.palette.secondary.main,
    height: '41px',
    width: '375px',
    padding: '0px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: 'black',
  },
  resize5: {
    height: '170px',
    width: '385px',
    padding: '5px 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    color: 'black',
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    maxHeight: '58vh',
    overflow: 'scroll',
  },
  placeHolderText: {
    border: 0,
    outline: 0,
    backgroundColor: Theme.palette.secondary.main,
    height: '104px',
    width: '375px',
    padding: '0 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '21px',
    /* identical to box height */

    display: 'flex',
    alignItems: 'center',

    /* Fields/Placeholder (light) */

    color: 'rgba(0, 0, 0, 0.4)',
  },
  listTextSelected: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  listTextNonSelected: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  listSubTextSelected: {
    color: Theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    marginTop: '5px',
  },
  listSubTextNonSelected: {
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    marginTop: '5px',
  },
  highlightItem: {
    borderRight: `4px solid ${Theme.palette.primary.main}`,
  },
  nonHighlightItem: {},

  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  popupSubHeading: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginTop: 0,
  },
  popupInputContainer: {
    textAlign: 'left',
    padding: '18px',
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  popInputs: {
    border: 0,
    outline: 0,
    backgroundColor: Theme.palette.secondary.main,
    height: '100px',
    width: '375px',
    padding: '0 10px',
    marginLeft: '0px',
    marginTop: '10px',
    marginBottom: '20px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '2px',
    lineHeight: '21px',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    marginRight: '28px',
  },
  popCancelBtn: {
    padding: '0 50px',
    height: '45px',
  },
  btnStyle: {
    height: '35px',

    width: '100%',
    marginBottom: '10px',
    backgroundColor: Theme.palette.secondary.main,
    color: Theme.palette.primary.main,
    '&:hover': {
      backgroundColor: Theme.palette.primary.main,
      color: Theme.palette.secondary.main,
    },
  },
  btnStyleNew: {
    height: '35px',
    width: '100%',
    marginBottom: '10px',
    backgroundColor: Theme.palette.primary.main,
    color: Theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: Theme.palette.primary.main,
      color: Theme.palette.secondary.main,
    },
  },
  btnUploadStyle: {
    height: '24px',
    background: Theme.palette.secondary.main,
    width: '100%',
    marginBottom: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',

    /* identical to box height */

    textAlign: 'center',
    letterSpacing: '0.2px',

    /* Background/Background (dark) */

    color: Theme.palette.quad.main,
  },
  btnStylemewtag: {
    background: Theme.palette.secondary.main,
    marginBottom: '10px',
    cursor: 'pointer',
    padding: '5px',
    color: Theme.palette.quad.main,
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  subheading: {
    fontSize: '12px',
    lineHeight: '15px',
    textAlign: 'left',
    marginBottom: '10px',
  },
}));

export const JourneyAddnewGuide = (props) => {
  const classes = useStyles();
  const { fetchDetails } = useAiExercise();
  const toastClass = MainLayoutStyles();
  const dispatch = useDispatch();
  const viewJourneyPop = props.open;
  const profilePics = [];
  const profilePicsID = [];
  const proText = [];

  const [selected, setSelected] = useState([]);
  const [imageData, setImageData] = useState();
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [thumbnailFileName, setThumbnailFileName] = useState('');
  const [guideTitle, setGuideTitle] = useState('');
  const [guideOverview, setGuideOverview] = useState('');
  const [urlValue, setUrlValue] = useState('');
  const [videoLink, setVideoLink] = useState('');
  const [skillFlag, setSkillFlag] = useState(0);
  const [skillLevel, setSkillLevel] = useState(0);
  const [openAddTag, setOpenAddTag] = useState(false);
  const [personImage, setPersonImage] = useState([]);
  const [personImageIDs, setPersonImageIDs] = useState([]);
  const [personText, setPersonText] = useState([]);
  const [showInstrList, setShowInstrList] = useState(false);
  const [openAddGuideInstructor, setOpenAddGuideInstructor] = useState(false);
  const [duration, setDuration] = useState('');
  const [defaultTags, setDefaultTags] = useState([]);
  const [av, setAV] = useState(null);
  const [decryptedURL, setDecryptedURL] = useState('');
  const [isValidUrl, setIsValidUrl] = useState(true);

  const instrList = useSelector((state) => state.getGuideInstructorList.guideInstrList);
  const assignedinstr = useSelector((state) => state.getGuideDetails.guidedetails.sources);
  const guideTagList = useSelector((state) => state.getGuideTagList.guidetaglist);
  const checkedIntrList = useSelector((state) => state.getCheckedInstr.checkedInstructors);
  const selectedGuideId = useSelector((state) => state.getGuideID);
  const selectedLevelID = useSelector((state) => state.getSelectedLevelID);
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);

  useEffect(() => {
    const selectedCheck = [];
    const selInstr = [];
    instrList?.forEach((data, key) => {
      assignedinstr?.forEach((data1) => {
        if (data.id === data1.id) {
          selectedCheck.push(key);
          selInstr.push(data.id);
        }
      });
    });
    dispatch(getCheckedAssignedInstr(selectedCheck));
    dispatch(getCheckedInstr(selInstr));
  }, [assignedinstr]);

  useEffect(() => {
    if (!_isEmpty(av)) {
      const decodedLink = generateVideoUrl(av);
      setDecryptedURL(decodedLink);
    }
  }, [av]);

  const getGuideTags = async () => {
    const data = '';
    await service
      .get(apiEndpoints.GUIDE_TAGS, data)
      .then((response) => {
        dispatch(getGuideTagList(response));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const getInstructors = async () => {
    await service
      .get(apiEndpoints.JOURNEY_INSTRUCTOR)
      .then((response) => {
        dispatch(getGuideInstructorList('add', response));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getGuides = async () => {
    const selArr = [];
    const data = '';
    await service
      .get(apiEndpoints.JOURNEY_GUIDE_BY_ID.replace('GUIDE_ID', selectedGuideId), data)
      .then((response) => {
        dispatch(getGuideDetails(response));
        setDefaultTags([...response.guideTags]);
        if (response.skillLevel === 'novice') {
          setSkillFlag(1);
          setSkillLevel('novice');
        } else if (response.skillLevel === 'intermediate') {
          setSkillFlag(2);
          setSkillLevel('intermediate');
        } else if (response.skillLevel === 'expert') {
          setSkillFlag(3);
          setSkillLevel('expert');
        }
        setGuideTitle(response.title);
        setGuideOverview(response.description);
        setThumbnail(response.thumbnail);
        setUrlValue(response.contentUrl);
        setDuration(response.duration);
        setAV(response.av);
        setVideoLink(response.av?.url ? response.av?.url : '');
        response.guideTags?.forEach((val, key) => {
          selArr[key] = val.id;
        });
        setSelected(selArr);

        const srcPics = [];
        const srcNames = [];
        const srcIds = [];

        response.sources.forEach((datas) => {
          srcPics.push(datas.thumbnail);
          srcNames.push(datas.name);
          srcIds.push(datas.id);
        });
        setPersonImage(srcPics);
        setPersonImageIDs(srcIds);
        if (srcPics.length === 1) {
          setPersonText(srcNames[0]);
        } else if (srcPics.length > 1) {
          const c = srcPics.length - 1;
          setPersonText(`${srcNames[0]} and ${c} others`);
        } else {
          setPersonText('');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    dispatch(showProgress(true));
    dispatch(getCheckedAssignedInstr([]));
    dispatch(getCheckedInstr([]));
    getGuideTags();
    getInstructors();
    if (props.view === true) {
      getGuides();
    }
  }, []);

  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };
  const handleCloseInstrList = () => {
    setShowInstrList(false);
  };
  const assignInstructorFn = () => {
    setShowInstrList(true);
  };
  const handleAssignInstr = () => {
    instrList?.forEach((data1) => {
      if (checkedIntrList?.includes(data1.id)) {
        const index1 = profilePics.indexOf(data1.thumbnail);
        if (index1 > -1) {
          profilePics.splice(index1, 1);
        } else {
          profilePics.push(data1.thumbnail);
        }
        const index2 = profilePicsID.indexOf(data1.id);
        if (index2 > -1) {
          profilePicsID.splice(index2, 1);
        } else {
          profilePicsID.push(data1.id);
        }
        const index3 = proText.indexOf(data1.name);
        if (index3 > -1) {
          proText.splice(index3, 1);
        } else {
          proText.push(data1.name);
        }
      }
    });
    setPersonImage(profilePics);
    setPersonImageIDs(profilePicsID);
    dispatch(getCheckedInstr(profilePicsID));
    if (profilePics.length === 1) {
      setPersonText(proText[0]);
    } else if (profilePics.length > 1) {
      const c = proText.length - 1;
      setPersonText(`${proText[0]} and ${c} others`);
    } else {
      setPersonText('');
    }
  };
  const openAddGuideInstructorPopup = () => {
    setOpenAddGuideInstructor(true);
  };
  const handleCloseAddGuideInstructor = () => {
    setOpenAddGuideInstructor(false);
  };
  const openAddTagPopup = () => {
    setOpenAddTag(true);
  };
  const handleCloseAddNewTag = () => {
    setOpenAddTag(false);
  };
  const notifySuccess = () => {
    toast.success('Saved Successfully', {
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true,
      className: toastClass.toastSuccess,
    });
  };
  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (personImageIDs?.length <= 0) {
      formIsValid = false;
      errors.push('Please select an instructor');
    }
    if (!guideTitle) {
      formIsValid = false;
      errors.push('Please enter guide title.');
    }
    if (!guideOverview) {
      formIsValid = false;
      errors.push('Please enter guide overview.');
    }
    if (!thumbnail && !imageData) {
      formIsValid = false;
      errors.push('Please select an image');
    }
    if (!skillLevel) {
      formIsValid = false;
      errors.push('Please select a skill level');
    }
    if (!urlValue && !videoLink) {
      formIsValid = false;
      errors.push('Please enter content or video link ');
    }
    if (!duration) {
      formIsValid = false;
      errors.push('Please enter duration');
    }

    if (errors.length !== 0) {
      notifyEditError(errors);
    }
    return formIsValid;
  };
  const notifyEditError = (msg) => {
    toast.error(
      <>
        {msg.map((x) => (
          <div> {x}</div>
        ))}
      </>,
      {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
      },
    );
  };
  const onTagSelect = (event, value) => {
    const tempSelected = [];
    value.forEach((element) => {
      tempSelected?.push(element.id);
    });
    setSelected([...tempSelected]);
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageData(file);
    setThumbnailFileName(file?.name);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setThumbnailImg(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = () => {
    setImageData(undefined);
    setThumbnail('');
    setThumbnailImg(null);
    setThumbnailFileName('');
  };

  const submit = async (edit) => {
    const datas = new FormData();
    const check = validateForm();
    if (check) {
      dispatch(showProgress(true));
      if (edit === false) {
        datas.append('levelId', selectedLevelID);
        datas.append('title', guideTitle);
        datas.append('description', guideOverview);
        datas.append('duration', duration);
        datas.append('skillLevel', skillLevel);
        personImageIDs.map((val) => datas.append('sourceIds', val));
        if (urlValue != null && urlValue !== '') {
          datas.append('contentUrl', urlValue);
        }
        if (videoLink != null && videoLink !== '') {
          datas.append('videoLink', decryptedURL);
        }
        datas.append('thumbnail', imageData);
        selected?.map((val, key) => datas.append('tagIds', String(selected[key])));
        await service
          .post(apiEndpoints.GUIDE_CREATE, datas)
          .then(async (response) => {
            notifySuccess('Saved Successfully');
            fetchDetails(selectedLevelID);
            dispatch(getGuideDetails(response));
            // Fetch updated journey details from API
            if (journeyDetails?.id) {
              const journeyResponse = await service.get(
                apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyDetails.id),
                '',
              );
              dispatch(getJourneyDetails('updateJourneyDetails', journeyResponse));
            }
            closePopup();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            console.log(error.response);
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      } else {
        datas.append('levelId', selectedLevelID);
        datas.append('title', guideTitle);
        datas.append('description', guideOverview);
        datas.append('duration', duration);
        datas.append('skillLevel', skillLevel);
        personImageIDs.map((val) => datas.append('sourceIds', val));
        if (urlValue != null && urlValue !== '') {
          datas.append('contentUrl', urlValue);
        }
        if (videoLink != null && videoLink !== '') {
          datas.append('videoLink', decryptedURL);
        }
        if (imageData !== undefined) {
          datas.append('thumbnail', imageData);
        }
        selected?.map((val, key) => datas.append('tagIds', String(selected[key])));
        await service
          .put(apiEndpoints.GUIDE_UPDATE.replace('GUIDE_ID', selectedGuideId), datas)
          .then((response) => {
            notifySuccess('Saved Successfully');
            dispatch(getGuideDetails(response));
            fetchDetails(selectedLevelID);
            closePopup();
            dispatch(showProgress(false));
          })
          .catch((error) => {
            ErrorToast(error);
            dispatch(showProgress(false));
          });
      }
    }
  };
  const handleUrlChange = (e) => {
    setUrlValue(e.target.value);
  };
  const handleVideoLinkChange = (inputValue) => {
    setVideoLink(inputValue);
    if (av && inputValue === av.url) {
      setDecryptedURL(generateVideoUrl(av));
    } else if (inputValue && inputValue !== av?.url) {
      setDecryptedURL(inputValue);
    } else {
      setDecryptedURL('');
    }
    if (!inputValue) {
      setIsValidUrl(true);
      setDecryptedURL('');
    }
  };
  const handleGuideTitleChange = (e) => {
    setGuideTitle(e.target.value);
  };
  const handleGuideOverviewChange = (e) => {
    setGuideOverview(e.target.value);
  };

  const closePopup = () => {
    props.close();
  };
  return (
    <Modal isOpen={viewJourneyPop} height="87vh" width="850px">
      <div>
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
          <Grid item xs={11}>
            <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start">
              <Grid item className={classes.popupHeading}>
                {props.view === false ? 'Adding a new guide' : 'Guide details'}
              </Grid>
              {props.view ? (
                <Grid item className={classes.subheading}>
                  Guide ID: {selectedGuideId}
                </Grid>
              ) : null}
            </Grid>
          </Grid>
          <Grid itemxs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
          </Grid>
        </Grid>
        <Grid container direction="row" style={{ height: 'auto' }} justifyContent="center" alignItems="flex-start">
          <Grid item xs={6} style={{ maxHeight: '100%', width: '100%', overflowY: 'auto' }}>
            <div className={classes.popupLabels}>
              <label htmlFor="guideOverview" className={classes.required_field}>
                Title
              </label>
            </div>
            <Grid
              container
              direction="column"
              style={{ height: '100%', width: '100%' }}
              justifyContent="space-evenly"
              alignItems="flex-start"
            >
              <TextField
                id="guideTitleId"
                name="guideTitle"
                required
                autoFocus
                autoComplete="off"
                autoSave="off"
                onChange={handleGuideTitleChange}
                placeholder="Enter guide's title here"
                multiline
                InputProps={{
                  disableUnderline: true,

                  classes: {
                    input: classes.resize,
                  },
                }}
                value={guideTitle}
                rows={5}
              />
              <div className={classes.popupLabels}>
                <label htmlFor="guideOverview" className={classes.required_field}>
                  Thumbail Image(Max-size 100KB)
                </label>
              </div>
              <Grid container direction="column" style={{ width: '395px' }}>
                <Grid item>
                  <CustomUploadField
                    type="image"
                    name="thumbnail"
                    value={thumbnailImg}
                    imgSrc={!imageData ? thumbnail : null}
                    handleChange={handleImageChange}
                    customStyles={{ width: '100%' }}
                    fileName={thumbnailFileName}
                    dimensions={DIMENSIONS.guide}
                    handleDelete={handleDeleteImage}
                    containerStyles={{
                      backgroundColor: Theme.palette.secondary.main,
                      border: 'none',
                      borderRadius: '0px',
                    }}
                  />
                </Grid>
              </Grid>
              <div className={classes.popupLabels}>
                <label htmlFor="upload_s3_interaction">Upload interaction to s3</label>
              </div>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="flex-end"
                className={classes.resize4}
                style={{ marginBottom: '20px' }}
              >
                <Grid item>
                  <UploadFolderButton name="upload_s3_interaction" urlValue={urlValue} setUrlValue={setUrlValue} />
                </Grid>
              </Grid>
              <div className={classes.popupLabels}>
                <label htmlFor="guideOverview">Interaction Link</label>
              </div>
              <TextField
                id="linkId"
                name="link"
                required
                autoComplete="off"
                autoSave="off"
                onChange={handleUrlChange}
                placeholder="Paste content link here(Optional)"
                multiline
                value={urlValue === 'null' ? '' : urlValue}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: classes.resize3,
                  },
                }}
                rows={1}
              />
              <VideoLinkInput
                value={videoLink}
                onChange={handleVideoLinkChange}
                label="Video Link"
              />

              <div className={classes.popupLabels}>
                <label htmlFor="guideOverview" className={classes.required_field}>
                  Course Overview
                </label>
              </div>

              <TextField
                id="guideOverviewId"
                name="guideOverviewName"
                required
                autoComplete="off"
                autoSave="off"
                onChange={handleGuideOverviewChange}
                placeholder="Enter guide overview here"
                multiline
                value={guideOverview}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: classes.resize2,
                  },
                }}
                rows={5}
              />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.popupLabels}>
              <label htmlFor="videoPreviewo">VIDEO PREVIEW</label>
            </div>

            {decryptedURL ? (
              <Grid className={classes.resize5}>
                <CustomReactPlayer
                  url={decryptedURL}
                  width="100%"
                  height="100%"
                  onError={() => {
                    setDecryptedURL('');
                    setIsValidUrl(false);
                  }}
                />
              </Grid>
            ) : (
              <ZeroState
                Icon={ExclamationIcon}
                text={
                  isValidUrl
                    ? 'Add video link for the video preview to be visible'
                    : 'Not able to render the video. Please verify if video URL is valid.'
                }
                style={{ marginBottom: '30px', marginTop: '20px', width: '400px', height: '170px' }}
                type="video"
                iconColor={isValidUrl ? '#98A2B3' : '#D92D20'}
              />
            )}

            <div className={classes.popupLabels}>
              <label htmlFor="guideOverview" className={classes.required_field}>
                Instructors
              </label>
            </div>
            <Grid
              container
              direction="row"
              justifyContent="space-evenly"
              alignItems="flex-start"
              style={{ marginTop: '3vh' }}
            >
              <Grid item>
                <Grid container direction="row" alignItems="flex-start">
                  <Grid item onClick={() => assignInstructorFn()}>
                    <Grid
                      container
                      direction="row"
                      style={{ marginTop: '0px' }}
                      className={classes.resize3}
                      justifyContent="space-between"
                    >
                      <Grid item>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                          <Grid item>
                            {personText !== '' ? (
                              <AvatarGroupComp pro={personImage} txt={personText} sub="Instructors in this guide" />
                            ) : (
                              'No Instructors yet'
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Grid container direction="row">
                          <Grid item>
                            <EditTwoTone />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Filter style={{ width: '32px', height: '40px' }} onClick={openAddGuideInstructorPopup} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <div className={classes.popupLabels}>
                  <label htmlFor="guideOverview" className={classes.required_field}>
                    Duration (seconds)
                  </label>
                </div>
                <TextField
                  id="durationId"
                  name="duration"
                  required
                  autoComplete="off"
                  autoSave="off"
                  onChange={handleDurationChange}
                  placeholder="Enter Duration "
                  multiline
                  value={duration}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      input: classes.resize3,
                    },
                  }}
                  rows={1}
                />
              </Grid>
              <Grid item>
                <Grid container style={{ marginBottom: '20px' }}>
                  <p className={classes.courseovtitle}>
                    <label className={classes.required_field}>SKILL LEVEL</label>
                  </p>
                  <Grid item xs={12}>
                    <Grid container direction="row" justifyContent="space-between" alignItems="center">
                      <Grid item style={{ width: '30%' }}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setSkillFlag(1);
                            setSkillLevel('novice');
                          }}
                          style={{
                            backgroundColor:
                              skillFlag === 1 ? Theme.palette.primary.main : Theme.palette.secondary.main,
                            color: skillFlag === 1 ? Theme.palette.secondary.main : Theme.palette.primary.main,
                          }}
                          name="skillLevel"
                          disableElevation
                          className={classes.btnStyle}
                        >
                          Beginner
                        </Button>
                      </Grid>
                      <Grid item style={{ width: '30%' }}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setSkillFlag(2);
                            setSkillLevel('intermediate');
                          }}
                          style={{
                            backgroundColor:
                              skillFlag === 2 ? Theme.palette.primary.main : Theme.palette.secondary.main,
                            color: skillFlag === 2 ? Theme.palette.secondary.main : Theme.palette.primary.main,
                          }}
                          name="skillLevel"
                          disableElevation
                          className={classes.btnStyle}
                        >
                          Intermediate
                        </Button>
                      </Grid>
                      <Grid item style={{ width: '30%' }}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setSkillFlag(3);
                            setSkillLevel('expert');
                          }}
                          style={{
                            backgroundColor:
                              skillFlag === 3 ? Theme.palette.primary.main : Theme.palette.secondary.main,
                            color: skillFlag === 3 ? Theme.palette.secondary.main : Theme.palette.primary.main,
                          }}
                          name="skillLevel"
                          disableElevation
                          className={classes.btnStyle}
                        >
                          Expert
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {defaultTags.length > 0 && (
                  <Grid container direction="column">
                    <p className={classes.popupLabels}>Guide Tags</p>
                    <Grid item>
                      <Grid container direction="row">
                        <Grid item xs={11}>
                          <Autocomplete
                            multiple
                            id="multiple-limit-tags"
                            options={guideTagList || []}
                            getOptionLabel={(option) => option.title}
                            isOptionEqualToValue={(op, val) => op.id === val.id}
                            defaultValue={defaultTags?.length > 0 ? [...defaultTags] : []}
                            filterSelectedOptions
                            renderInput={(params) => <TextField {...params} placeholder="Tags" disableUnderline />}
                            onChange={onTagSelect}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <AddIcon className={classes.btnStylemewtag} onClick={openAddTagPopup} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {defaultTags.length === 0 && (
                  <Grid container direction="column">
                    <p className={classes.popupLabels}>Guide Tags</p>
                    <Grid item>
                      <Grid container direction="row">
                        <Grid item xs={11}>
                          <Autocomplete
                            multiple
                            id="multiple-limit-tags"
                            options={guideTagList || []}
                            getOptionLabel={(option) => option.title}
                            isOptionEqualToValue={(op, val) => op.id === val.id}
                            defaultValue={defaultTags?.length > 0 ? [...defaultTags] : []}
                            filterSelectedOptions
                            renderInput={(params) => <TextField {...params} placeholder="Tags" disableUnderline />}
                            onChange={onTagSelect}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <AddIcon className={classes.btnStylemewtag} onClick={openAddTagPopup} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid item style={{ marginTop: '20px' }}>
                <Button
                  variant="contained"
                  onClick={closePopup}
                  disableElevation
                  style={{
                    width: '175px',
                    height: '42px',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '17px',
                    textAlign: 'center',
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    width: '175px',
                    height: '42px',
                    marginLeft: '20px',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '17px',
                    textAlign: 'center',
                  }}
                  onClick={() => submit(props.view)}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {openAddGuideInstructor && (
          <AddGuideInstructor open edit={false} type="INSTRUCTOR" close={handleCloseAddGuideInstructor} />
        )}
        {openAddTag && <AddNewTag open type="guide" close={handleCloseAddNewTag} />}
        {showInstrList && (
          <AssignInstructor
            open
            close={handleCloseInstrList}
            add
            handleAssignInstr={handleAssignInstr}
            iList={instrList || null}
          />
        )}
      </div>
    </Modal>
  );
};
